import { render } from "./UserForm.vue?vue&type=template&id=3be8514c&scoped=true&ts=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"

import "./UserForm.vue?vue&type=style&index=0&id=3be8514c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be8514c"]])

export default __exports__